import React from 'react';
import { useStore } from '../context/StoreContext';
import { Icons } from './Icons';
import Link from './Link';
import './Navbar.css';

export default function Navbar() {
  const { page, navigate, goShop, openWA, cartCount, setCartOpen, mobOpen, setMobOpen, secretClick, currentUser } = useStore();

  const accountLabel = currentUser
    ? (currentUser.displayName?.split(' ')[0] || 'Account')
    : 'Login';

  return (
    <>
      {/* Announcement Bar */}
      <div className="announcement-bar">
        ✦ Free Delivery on Orders Above Rs. 3,000 &nbsp;·&nbsp; WhatsApp Orders Welcome ✦
      </div>

      {/* Main Nav */}
      <nav className="navbar">
        <div className="navbar-inner">
          <Link href="/" className="nav-brand" onClick={() => navigate('home')} aria-label="City Shopping Center home">
            <img className="nav-logo-img" src="/logo.jpeg" alt="City Shopping Center logo" />
            <div className="nav-logo-text">
              CITY SHOPPING CENTER
              <span>& Dulha House · Est. 2001</span>
            </div>
          </Link>

          <div className="nav-links">
            {[['home','Home'],['shop','Shop'],['blog','Blog'],['about','About'],['contact','Contact']].map(([id, label]) => (
              <Link
                key={id}
                href={id === 'home' ? '/' : '/' + id}
                className={`nav-link${page === id || (id === 'blog' && page === 'blogpost') ? ' active' : ''}`}
                onClick={() => id === 'shop' ? goShop('All') : navigate(id)}
              >
                {label}
              </Link>
            ))}
          </div>

          <div className="nav-actions">
            <Link
              href="/account"
              className={`btn-nav-account${page === 'account' ? ' active' : ''}`}
              onClick={() => navigate('account')}
              title={currentUser ? 'My Account' : 'Login'}
            >
              {Icons.lock(15)} {accountLabel}
            </Link>
            <button className="btn-nav-wa" onClick={openWA}>
              {Icons.whatsapp(15)} WhatsApp
            </button>
            <button className="btn-nav-cart" onClick={() => setCartOpen(true)}>
              {Icons.cart(16)}
              <span className="cart-badge">{cartCount}</span>
            </button>
            <button className="btn-burger" onClick={() => setMobOpen(!mobOpen)}>
              {Icons.menu()}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu${mobOpen ? ' open' : ''}`}>
        {[['home','Home'],['shop','Shop All'],['blog','Blog'],['about','About'],['contact','Contact']].map(([id, label]) => (
          <Link
            key={id}
            href={id === 'home' ? '/' : '/' + id}
            className="mobile-link"
            onClick={() => id === 'shop' ? goShop('All') : navigate(id)}
          >
            {label}
          </Link>
        ))}
        <Link
          href="/account"
          className="mobile-link"
          onClick={() => navigate('account')}
        >
          {currentUser ? `My Account (${accountLabel})` : 'Login / Sign Up'}
        </Link>
      </div>

      {/* Secret Admin Button */}
      <button className="secret-admin-btn" onClick={secretClick} aria-hidden="true" />
    </>
  );
}
